var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-wrapper',{attrs:{"title":_vm.title}},[_c('appointment-filter-bar',{on:{"search":_vm.handleSearch},model:{value:(_vm.filterForm),callback:function ($$v) {_vm.filterForm=$$v},expression:"filterForm"}}),_vm._v(" "),_c('appointment-table',{attrs:{"data":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }